import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {SessionService} from '../../../../services/session.service';
import {DialogService} from '../../../../services/dialog.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-menu-movil',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuMovilComponent implements OnInit {
  inSessionFlag: boolean;
  constructor(
    private matDialogRef: MatDialogRef<MenuMovilComponent>,
    private sessionService: SessionService,
    private dialogService: DialogService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }
  inSession(): boolean {
    const auth = this.sessionService.getAuthData();
    const sess = this.sessionService.getLoginSession();
    return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null') ? true : false;
  }

  close(): void {

    this.matDialogRef.close();
  }
  navigateTo(route: string) {

    console.log(route)
    setTimeout(() => {
    this.router.navigate([route])
  }, 300);
    sessionStorage.setItem('ancla','inicio')
    this.matDialogRef.close();
  }
  changeLanguage(): void {
    switch (this.router.url) {
      case '/':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/';
        break;
      case '/firma-digital-para-personas':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-para-pessoas';
        break;
      case '/firma-digital-para-empresas':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-para-empresas';
        break;
      case '/como-empezar-a-firmar-digitalmente':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/como-comecar-a-assinar-digitalmente';
        break;
      case '/preguntas-frecuentes-de-la-firma-digital-fad':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/perguntas-frequentes-da-assinatura-digital-fad';
        break;
      case '/firma-digital-gratis':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-gratis';
        break;
      case '/aviso-de-privacidad':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/termos-e-condicoes';
        break;
      case '/cumplimiento-juridico-de-la-firma-digital':
        window.location.href = 'https://www.assinaturaautografadigital.com.br/conformidade-legal-da-assinatura-digital';
        break;
    }
  }

  login(isLogIn: boolean): void {
    this.inSessionFlag = this.inSession();
    if (this.inSessionFlag) {
      this.dialogService.showConfirmationDialog(
        'Confirmar operación',
        '- ¿  Seguro que quieres cerrar la sesión  ? -',
        () => {
          sessionStorage.clear();
          localStorage.clear();
          this.sessionService.setPromoCode(null);
          window.location.reload();
        }
      );
    } else {
      if (isLogIn) {
        if (this.inSessionFlag) {
          this.sessionService.clearData();
        } else {
          this.setInitText(false);
        }
      } else {
        this.setInitText(true);
      }
    }
  }
  setInitText(value): void {
    this.sessionService.setInitText(value);
    setTimeout(() => {
      if (this.router.url === '/firma-digital-gratis') {
        this.sessionService.emitNewSessionText(value);
      } else {
        this.router.navigate(['/firma-digital-gratis']);
      }
    }, 200);
  }
}
